import { Options, Vue } from 'vue-class-component';
import Toggle from '@vueform/toggle';

import * as CompanySegmentService from '@/services/company-segment.service';

@Options({
  name: 'company-segment-new',
  components: {
    Toggle,
  },
})
export default class CompanySegmentNew extends Vue {
  public errorMessage = '';
  public errors: any = {};
  public hasError = false;
  public row = {
    description: '',
    enabled: true,
  };

  public goBack() {
    this.$router.push('/company-segment');
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.description) {
      this.errors.description = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      CompanySegmentService.insert({
        description: this.row.description,
        enabled: this.row.enabled,
})
        .then(() => {
          this.$router.push('/company-segment');
        })
        .catch(() => {
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.';
        });
    }
  }
}
